import type { FaireProductEntity } from "../../entity_types/product";

export const p_duggnjqf9g: FaireProductEntity = {
  token: "p_duggnjqf9g",
  type: "product",
  name: "Ladybug Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4745033616a8b96e8637a2e5ee0cc793a7e0b6f27b661569efa48e29a5a2d4a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ebe2f9b97326ae8cda6125bd538d2e8b13c850dc8c5cd379a0fefbff8675f4f.jpeg",
    "https://cdn.faire.com/fastly/d810fd72f0d0474f38277e2bc1aa65b7544c71011971669b0c8ac148eaee7494.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:21.179Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
